import axios from "axios";

export const getTestData = async () => {
  try {
    const response = await axios.get(
      "https://temel-analiz-raporu-api.vercel.app/api/test"
    );
    // console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Test verisi alınırken hata oluştu:", error);
    throw error;
  }
};

// Hisse listesini getiren fonksiyon
export const getHisseListesi = async () => {
  if (process.env.NODE_ENV === "development") {
    const response = await axios.get("/development/hisseler.json");
    return response.data;
  } else {
    const response = await axios.get(
      "https://temel-analiz-raporu-api.vercel.app/api/hisseler"
    );
    return response.data.data;
  }
};

// Gelişim ortamına veya üretim ortamına göre hisse verilerini getiren fonksiyon
export const getHisseData = async (hisse, updateLoadingState) => {
  if (process.env.NODE_ENV === "development") {
    return await fetchLocalHisseData(updateLoadingState);
  } else {
    return await fetchApiHisseData(hisse.hisse_kodu, updateLoadingState);
  }
};

// Yerel JSON verisini getiren fonksiyon
export const fetchJsonData = async (
  fileName,
  loadingKey,
  updateLoadingState
) => {
  const response = await axios.get(`/${fileName}`);

  // Yükleme durumunu güncelle (varsa)
  if (updateLoadingState && loadingKey) {
    updateLoadingState(loadingKey, true);
  }

  return response.data.data || response.data;
};

// Yerel veri kaynağından bir hissenin temel analiz verilerini getiren fonksiyon
export const fetchLocalHisseData = async (updateLoadingState) => {
  const bilancoVerileri = await fetchJsonData(
    "development/bilanco.json",
    "bilanco",
    updateLoadingState
  );
  const gelirTablosuVerileri = await fetchJsonData(
    "development/gelir-tablosu.json",
    "gelirTablosu",
    updateLoadingState
  );
  const sermayeArtirimlariTemettuler = await fetchJsonData(
    "development/sermaye-artirimlari-temettuler.json",
    "sermayeArtirimlari",
    updateLoadingState
  );
  const tarihselFiyatBilgileri = await fetchJsonData(
    "development/tarihsel-fiyat-bilgileri.json",
    "tarihselFiyat",
    updateLoadingState
  );
  const sirketBilgileri = await fetchJsonData(
    "development/sirket-bilgileri.json",
    "sirketBilgileri",
    updateLoadingState
  );

  return {
    bilancoVerileri,
    gelirTablosuVerileri,
    sermayeArtirimlariTemettuler,
    tarihselFiyatBilgileri,
    sirketBilgileri,
  };
};

// API'den bir hissenin temel analiz verilerini getiren fonksiyon
export const fetchApiHisseData = async (hisseKodu, updateLoadingState) => {
  const fetchData = async (url, loadingKey) => {
    try {
      const response = await axios.get(url);

      // Yükleme durumunu güncelle (varsa)
      if (updateLoadingState && loadingKey) {
        updateLoadingState(loadingKey, true);
      }

      return response.data.data || response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Veri bulunamadı:", error.response.data.message);

        // Hata durumunda da yükleme durumunu güncelle (varsa)
        if (updateLoadingState && loadingKey) {
          updateLoadingState(loadingKey, true, true); // Üçüncü parametre hata durumunu belirtir
        }

        return null;
      } else {
        console.error("API'den veri alınırken hata oluştu:", error);

        // Hata durumunda da yükleme durumunu güncelle (varsa)
        if (updateLoadingState && loadingKey) {
          updateLoadingState(loadingKey, true, true);
        }

        throw error; // Diğer hataları yeniden fırlat
      }
    }
  };

  // API çağrılarını tanımlayalım
  const fetchRequests = [
    {
      url: `https://temel-analiz-raporu-api.vercel.app/api/bilanco?hisse=${hisseKodu}`,
      loadingKey: "bilanco",
    },
    {
      url: `https://temel-analiz-raporu-api.vercel.app/api/gelir-tablosu?hisse=${hisseKodu}`,
      loadingKey: "gelirTablosu",
    },
    {
      url: `https://temel-analiz-raporu-api.vercel.app/api/sermaye-artirimlari-temettuler?hisse=${hisseKodu}`,
      loadingKey: "sermayeArtirimlari",
    },
    {
      url: `https://temel-analiz-raporu-api.vercel.app/api/tarihsel-fiyat-bilgileri?hisse=${hisseKodu}&toplam_yil=5`,
      loadingKey: "tarihselFiyat",
    },
    {
      url: `https://temel-analiz-raporu-api.vercel.app/api/sirket-bilgileri?hisse=${hisseKodu}`,
      loadingKey: "sirketBilgileri",
    },
  ];

  // Tüm API çağrılarını paralel olarak çalıştıralım
  const results = await Promise.all(
    fetchRequests.map((request) => fetchData(request.url, request.loadingKey))
  );

  // Sonuçları yapılandırılmış nesneye ayıralım
  return {
    bilancoVerileri: results[0],
    gelirTablosuVerileri: results[1],
    sermayeArtirimlariTemettuler: results[2],
    tarihselFiyatBilgileri: results[3],
    sirketBilgileri: results[4],
  };
};
